import { render, staticRenderFns } from "./gagc.vue?vue&type=template&id=0810c2a4&scoped=true&"
import script from "./gagc.vue?vue&type=script&lang=js&"
export * from "./gagc.vue?vue&type=script&lang=js&"
import style0 from "@/assets/iconFonts/iconfont.css?vue&type=style&index=0&id=0810c2a4&scoped=true&lang=css&"
import style1 from "./gagc.vue?vue&type=style&index=1&id=0810c2a4&scoped=true&lang=css&"
import style2 from "./gagc.vue?vue&type=style&index=2&id=0810c2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810c2a4",
  null
  
)

export default component.exports